import React from 'react';

import SubscriptionIcon from 'rebook/apps/base/components/icons/SubscriptionIcon';

import stylesInner from './style.scss';


export const StandardBtn = (props) => (
  <div className={stylesInner.standard}>
    <SubscriptionIcon
      {...props}
      type="standard"
      extraClassName={stylesInner.svg} />
  </div>
);

export const PremiumBtn = (props) => (
  <div className={stylesInner.premium}>
    <SubscriptionIcon
      {...props}
      type="premium"
      extraClassName={stylesInner.svg} />
  </div>
);

export const FreeBtn = (props) => (
  <div className={stylesInner.free}>
    <SubscriptionIcon
      {...props}
      type="free"
      extraClassName={stylesInner.svg} />
  </div>
);
